"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Focus = void 0;
var Focus;
(function (Focus) {
    Focus["FullBody"] = "fullbody";
    Focus["Core"] = "core";
    Focus["Legs"] = "legs";
    Focus["Arms"] = "arms";
    Focus["Chest"] = "chest";
    Focus["Mental"] = "mental";
    Focus["Back"] = "back";
    Focus["Glutes"] = "glutes";
    Focus["Shoulders"] = "shoulders";
})(Focus = exports.Focus || (exports.Focus = {}));
//# sourceMappingURL=Focus.js.map